<template>
  <footer class="footer">
    <div class="footer__contacts contacts hide-tablet hide-mobile">
      {{ $t("contacts") }}:

      <div
        style="display: inline"
        v-for="contact in userContact"
        v-bind:key="contact.setting_id"
      >
        <span class="contacts__item">
          <a :href="'tel:' + contact.phone" class="contacts__link">
            {{ contact.phone }}</a
          > </span
        >|
        <span class="contacts__item">
          <a :href="'mailto:' + contact.email" class="contacts__link">
            {{ contact.email }}
          </a>
        </span>
      </div>
    </div>

    <div class="contacts__copyright copyright">
      © First Heartland Securities {{ currentYear }}
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    // Возвращаем текущий год
    currentYear() {
      let date = new Date();
      return date.getFullYear();
    },

    ...mapGetters(["userContact"])
  },
  mounted() {
    // this.$store.dispatch("fetchContact");
  }
};
</script>

<style scoped>
.footer {
  height: 10vh;
  padding: 0 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  color: #acb5c5;
  background-color: #f0f1f3;
  box-sizing: border-box;
}

.contacts {
  float: left;
  padding: 15px;
}

.contacts__item {
  padding: 5px;
}

.contacts__link {
  padding: 5px;
  color: #1a75e9;
}

.copyright {
  float: right;
  padding: 15px;
}
</style>
